module.exports = __webpack_public_path__ + "static/media/LELE01.f9a35f2f.jpg";